/**
 * GlideJS.
 */

import Glide from "./glide.min.js";

const values = new Glide(".values-slider");
values.on("build.after", () => glideHandleHeight(".values-slider"));
values.on("run.after", () => glideHandleHeight(".values-slider"));
values.mount({
  type: "carousel",
  startAt: 0,
  perView: 1,
  focusAt: "0",
  hoverpause: false,
  animationDuration: 750
});

const testimonials = new Glide(".testimonial-slider");
testimonials.on("build.after", () => glideHandleHeight(".testimonial-slider"));
testimonials.on("run.after", () => glideHandleHeight(".testimonial-slider"));
testimonials.mount({
  type: "carousel",
  startAt: 0,
  perView: 1,
  focusAt: "0",
  hoverpause: false,
  animationDuration: 750
});

function glideHandleHeight(slider) {
  const activeSlide = document.querySelector(`${slider} .glide__slide--active`);
  const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;

  const glideTrack = document.querySelector(`${slider} .glide__track`);
  const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

  if (activeSlideHeight !== glideTrackHeight) {
    glideTrack.style.height = `${activeSlideHeight}px`;
  }
}